import React, { useEffect, useState } from "react";
import { getOfflineData } from "../../utils/offline-services";
import { useNavigate } from "react-router-dom";
import MuiTable from "../../component/mui-table";
import { getKowledgeBaseHeaderConfig } from "./config";
import { Box, Button, TextField, Typography } from "@mui/material";
import { HTTP_METHODS, invokeApi } from "../../utils/http-service";
import CustomModal from "../../component/modal";
import { HOSTNAME, REST_URLS } from "../../utils/endpoints";
import { toast } from "react-toastify";
import DeleteModal from "../../core/delete-modal";

const AdminKnowledgeBase = () => {
  const [formData, setFormData] = useState({});
  const [data, setData] = useState({});
  const [filters, setFilters] = useState({
    sortBy: "-createdAt",
    page: 1,
    limit: 10,
  });
  const [editKnowledgeBase, setEditKnowledgeBase] = useState({
    isOpen: false,
    data: {},
  });
  const [readMoreModal, setReadMoreModal] = useState({
    isOpen: false,
    text: "",
  });
  const [deleteModal, setDeleteModal] = useState({ isOpen: false, data: {} });
  const navigate = useNavigate();
  const user = getOfflineData("user");
  const updateHandler = (data, type) => {
    switch (type) {
      case "EDIT":
        setEditKnowledgeBase({
          isOpen: true,
          data: data,
        });
        setFormData({
          topic: data.topic,
          summary: data.summary,
          description: data.description,
        });
        break;
      case "DELETE":
        setDeleteModal({
          isOpen: true,
          data: data,
        });
        break;
      default:
        break;
    }
  };
  const updateknowledgeBase = () => {
    const payload = {};
    for (let i in formData) {
      if (formData[i]) {
        payload[i] = formData[i];
      }
    }

    if (editKnowledgeBase?.data?.id) {
      invokeApi(
        HTTP_METHODS.PUT,
        `${HOSTNAME}${REST_URLS.KNOWLEDGE_BASE}/${editKnowledgeBase.data.id}`,
        payload
      )
        .then((res) => {
          if (res.message) {
            toast.error(res.message, { autoClose: 2000 });
          } else {
            toast.success("Updated Successfully", { autoClose: 1000 });
            setFormData({});
            setEditKnowledgeBase({
              isOpen: false,
              data: {},
            });
            getData({ ...filters, page: 1 });
          }
        })
        .catch((err) => console.error(err));
    } else {
      invokeApi(
        HTTP_METHODS.POST,
        `${HOSTNAME}${REST_URLS.KNOWLEDGE_BASE}`,
        payload
      )
        .then((res) => {
          if (res.message) {
            toast.error(res.message, { autoClose: 2000 });
          } else {
            toast.success("Created Successfully", { autoClose: 1000 });
            setFormData({});
            setEditKnowledgeBase({
              isOpen: false,
              data: {},
            });
            getData({ ...filters, page: 1 });
          }
        })
        .catch((err) => console.error(err));
    }
  };
  const getData = (filter) => {
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.KNOWLEDGE_BASE}`,
      null,
      filter
    )
      .then((res) => {
        if (res.message) {
          toast.error(res.message, { autoClose: 2000 });
        } else {
          setData(res);
        }
      })
      .catch((err) => console.error(err));
  };
  const readMoreFunc = (data) => {
    setReadMoreModal(data);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevVal) => ({ ...prevVal, [name]: value }));
  };
  const deleteHandler = () => {
    if (deleteModal?.data?.id) {
      invokeApi(
        HTTP_METHODS.DELETE,
        `${HOSTNAME}${REST_URLS.KNOWLEDGE_BASE}/${deleteModal?.data?.id}`
      )
        .then((res) => {
          if (res.message) {
            toast.error(res.message, { autoClose: 2000 });
            setDeleteModal({
              isOpen: false,
              data: {},
            });
          } else {
            toast.success("Deleted Successfully", { autoClose: 2000 });
            setDeleteModal({
              isOpen: false,
              data: {},
            });
            getData({ ...filters, page: 1 });
          }
        })
        .catch((err) => console.error(err));
    }
  };
  useEffect(() => {
    if (user?.role !== "admin") {
      navigate("/");
    }
  }, []);
  useEffect(() => {
    getData(filters);
  }, []);
  return (
    <div>
      <div className="users-con">
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h5" className="primary-text">
            Knowledge Base
          </Typography>
          <Button
            size="small"
            variant="outlined"
            sx={{ mb: 1 }}
            onClick={() => {
              setEditKnowledgeBase({ isOpen: true, data: {} });
            }}
          >
            Add Knowledge Base
          </Button>
        </div>

        <MuiTable
          columnsList={getKowledgeBaseHeaderConfig()}
          dataList={data?.results || []}
          filters={filters}
          pageCount={data?.totalPages}
          onClick={updateHandler}
          maxWords="9"
          showAllFunc={readMoreFunc}
          onChange={(page) => {
            setFilters({
              ...filters,
              page,
            });
            getData({
              ...filters,
              page,
            });
          }}
        ></MuiTable>

        {data?.results?.length === 0 && (
          <Typography variant="h4" sx={{ textAlign: "center" }}>
            Knowledge Base Not Found
          </Typography>
        )}
        {editKnowledgeBase.isOpen && (
          <CustomModal
            title={
              editKnowledgeBase?.data.id
                ? "Edit Knowledge Base"
                : "Create Knowledge Base"
            }
            onClose={() => {
              setEditKnowledgeBase({
                isOpen: false,
                data: {},
              });
              setFormData({});
            }}
          >
            <Box sx={{ gridGap: "12px", display: "grid" }}>
              <TextField
                label="Topic"
                name="topic"
                size="small"
                value={formData?.topic}
                onChange={handleChange}
                fullWidth
              />
              <TextField
                label="Summary"
                name="summary"
                size="small"
                value={formData?.summary}
                onChange={handleChange}
                fullWidth
                multiline
                minRows={2}
              />
              <TextField
                label="Description"
                name="description"
                size="small"
                value={formData?.description}
                onChange={handleChange}
                fullWidth
                multiline
                minRows={5}
              />
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  onClick={updateknowledgeBase}
                  disabled={
                    !formData?.topic ||
                    !formData?.summary ||
                    !formData?.description
                  }
                  sx={{ mb: 5 }}
                >
                  Save
                </Button>
              </div>
            </Box>
          </CustomModal>
        )}
        {readMoreModal?.isOpen && (
          <CustomModal
            onClose={() => {
              setReadMoreModal({
                isOpen: false,
                text: "",
              });
            }}
          >
            <Typography variant="body1">{readMoreModal?.text}</Typography>
          </CustomModal>
        )}
        {deleteModal?.isOpen && (
          <DeleteModal
            onClose={() =>
              setDeleteModal({
                isOpen: false,
                data: {},
              })
            }
            deleteFunc={deleteHandler}
          />
        )}
      </div>
    </div>
  );
};

export default AdminKnowledgeBase;
